var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-top": "5px" } },
        [
          !_vm.isExpanded
            ? _c(
                "el-button",
                {
                  attrs: { no: "expandAll", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.isExpanded = !_vm.isExpanded
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Sop.Unfold")))]
              )
            : _c(
                "el-button",
                {
                  attrs: { no: "putItAllAway", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.isExpanded = !_vm.isExpanded
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close2")))]
              ),
          _vm.isEdit
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.commitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
              )
            : _vm._e(),
          _vm.isEdit
            ? _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
              )
            : _vm._e(),
          !_vm.isEdit
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.assemblyPlanCostIsEdit || !_vm.editable
                  },
                  on: { click: _vm.edit }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.isExpanded
        ? _c(
            "el-form",
            {
              staticClass: "assembly-plan-dialog-form",
              staticStyle: {
                "margin-top": "5px",
                display: "flex",
                "flex-wrap": "wrap"
              },
              attrs: {
                disabled: !_vm.isEdit,
                "label-width": _vm.$selectByLang("100px", "140px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_AirlineProductCode"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "airlineProductUuid",
                      clearable: false,
                      filterable: "",
                      "static-options": _vm.airlineProductDownList,
                      "method-params": { active: true },
                      "tag-value": "uuid",
                      "tag-name": "name",
                      "filter-tag-names": ["name"],
                      "static-component": new _vm.AutoComplete(),
                      "callback-method-type": "value",
                      "default-value": _vm.form.airlineProductUuid,
                      "callback-params": { key: "airlineProductUuid" }
                    },
                    on: { parentCallBack: _vm.airlineProductUuidChange }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.ServiceProduct"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "serviceProduct",
                      clearable: false,
                      filterable: "",
                      "select-type":
                        _vm.TYPE_NAMES.basic_data_AirServiceProduct,
                      "callback-method-type": "value",
                      "default-value": _vm.form.serviceProduct,
                      "callback-params": { key: "serviceProduct" }
                    },
                    on: {
                      parentCallBack: function(p) {
                        return (_vm.form.serviceProduct = p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.AirlineCompany"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "carrierId",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": {
                        airCmp: true,
                        companyLob: "airExport",
                        active: true
                      },
                      "default-value": _vm.form.carrierId || "",
                      headers: [
                        _vm.$t("Tool.ShortName"),
                        _vm.$t("Partners.chineseName")
                      ],
                      fields: ["shortName", "chineseName"],
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        return (_vm.form.carrierId = p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("AirExport.FlightNumber"),
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.flightNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "flightNumber", $$v)
                      },
                      expression: "form.flightNumber"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_FlightDate"),
                    required: ""
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      no: "flightDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                      clearable: false,
                      "picker-options": _vm.pickerOptions
                    },
                    on: { change: _vm.bringDataHandle },
                    model: {
                      value: _vm.form.flightDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "flightDate", $$v)
                      },
                      expression: "form.flightDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_OriginPort"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    ref: "portOfDeparture",
                    attrs: {
                      no: "portOfDeparture",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      "default-value": _vm.form.portOfDeparture,
                      "tag-name": "englishName",
                      placeholder: " ",
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portOfDeparture = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_DestinationPort"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    ref: "destinationPortCode",
                    attrs: {
                      no: "destinationPortCode",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      "default-value": _vm.form.destinationPortCode,
                      "tag-name": "code",
                      placeholder: " ",
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.destinationPortCode = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_DeliveryCargoStation"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "cargoTerminalOperation",
                      "select-type":
                        _vm.TYPE_NAMES.basic_data_AirportCargoTerminal,
                      "method-params": { dataType: 0, deletionFlag: false },
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.cargoTerminalOperation
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.cargoTerminalOperation = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_BaseWeight") } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      no: "basicWeight",
                      precision: 3,
                      min: 0,
                      "enforce-min": true
                    },
                    model: {
                      value: _vm.form.basicWeight,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "basicWeight", $$v)
                      },
                      expression: "form.basicWeight"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_LimitWeight") } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      no: "limitWeight",
                      precision: 3,
                      min: 0,
                      "enforce-min": true
                    },
                    model: {
                      value: _vm.form.limitWeight,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "limitWeight", $$v)
                      },
                      expression: "form.limitWeight"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_SellableSpace") } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      no: "availableCabinSpace",
                      precision: 3,
                      min: 0,
                      "enforce-min": true
                    },
                    model: {
                      value: _vm.form.availableCabinSpace,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "availableCabinSpace", $$v)
                      },
                      expression: "form.availableCabinSpace"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_TheoreticalVolume") }
                },
                [
                  _c("auto-number-input", {
                    attrs: {
                      no: "theoryVolume",
                      precision: 3,
                      min: 0,
                      "enforce-min": true
                    },
                    model: {
                      value: _vm.form.theoryVolume,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "theoryVolume", $$v)
                      },
                      expression: "form.theoryVolume"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_SellableVolume") } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      no: "sellableVolume",
                      precision: 3,
                      min: 0,
                      "enforce-min": true
                    },
                    model: {
                      value: _vm.form.sellableVolume,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "sellableVolume", $$v)
                      },
                      expression: "form.sellableVolume"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ShipmentOrder"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "instructionType",
                      "tag-value": "code",
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.outboundInstruction,
                      "static-options":
                        _vm.SystemConstants.OUTBOUND_INSTRUCTIONS
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.outboundInstruction = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }